export const initPress = () => {
	const press = document.querySelectorAll( 'section.press > ul' );

	return;

	if ( !press )
	{
		return;
	}

	const columnsHandle = ( it ) => {
		it.style.height = '';

		if ( window.innerWidth < 768 )
		{
			return;
		}

		it.style.height = `${it.offsetHeight / 2 + it.querySelector( 'li:last-child' ).offsetHeight / 3}px`;
	};

	Array.from( press ).forEach( ( it ) => {
		columnsHandle( it );

		window.addEventListener( 'resize', () => {
			columnsHandle( it );
		} );
	} );
};
